import RadioGroupWithLabel from './RadioGroupWithLabel';

export default RadioGroupWithLabel;
